<template>
  <v-content>
    <v-container my-10>
      <v-layout align-center justify-center>
        <v-progress-circular
          :size="55"
          :width="4"
          indeterminate
          color="primary"
          class="mt-12"
          v-if="loading"
        ></v-progress-circular>
        <v-card v-if="!loading" max-width="650px">
          <v-card-title>
            <span class="headline">{{
              $t("users.dealersDetails.preview")
            }}</span>
            <v-btn
              v-if="canUseKnowledgeBaseBtn"
              color="primary"
              @click="handleHelp"
              icon
            >
              <v-icon class="mx-2">mdi-help-circle</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-card-actions>
              <v-btn text color="primary" @click="edit()"
                ><v-icon small class="mx-2">mdi-pencil</v-icon
                >{{ $t("users.dealersDetails.edit") }}</v-btn
              >
              <v-btn
                text
                color="red"
                v-if="!accountView && canUserDelete"
                @click="deleteFn()"
              >
                <v-icon small class="mx-2">mdi-delete</v-icon
                >{{ $t("users.dealersDetails.delete") }}</v-btn
              >
            </v-card-actions>
          </v-card-title>
          <v-card-text>
            <partner-banner :banner="partnerBanner"></partner-banner>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-card elevation="0" pa-1 ma-1>
                    <v-card-title class="subtitle-1">{{
                      $t("users.dealersDetails.companyDisplayName")
                    }}</v-card-title>
                    <v-card-subtitle> {{ editedItem.name }}</v-card-subtitle>
                  </v-card>
                </v-col>

                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-card elevation="0" pa-1 ma-1>
                    <v-card-title class="subtitle-1">{{
                      $t("users.dealersDetails.companyLegalName")
                    }}</v-card-title>
                    <v-card-subtitle>
                      {{ editedItem.company_name }}</v-card-subtitle
                    >
                  </v-card>
                </v-col>

                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                  v-if="!isInternalPartner"
                >
                  <v-card elevation="0">
                    <v-card-title class="subtitle-1">{{
                      $t("users.dealersDetails.brands")
                    }}</v-card-title>
                    <v-card-subtitle>
                      <v-chip
                        v-bind:key="brands.uuid"
                        v-for="brands in editedItem.brands"
                        class="ma-1"
                      >
                        <span>{{ brands.name }}</span>
                      </v-chip>
                    </v-card-subtitle>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-card elevation="0">
                    <v-card-title class="subtitle-1">{{
                      $t("users.dealersDetails.users")
                    }}</v-card-title>
                    <v-card-subtitle>
                      <v-list v-for="user in editedItem.users" :key="user.uuid">
                        <user-email-component
                          :user="user"
                          :contact-email="editedItem.email"
                          :readonly="true"
                          :changeRole="false"
                        >
                          <template
                            slot="role"
                            v-if="
                              typeof user.labels !== 'undefined' &&
                              user.labels.length !== 0
                            "
                          >
                            <v-chip
                              outlined
                              class="mt-2 mr-1"
                              v-for="item in getRolePrettified(user.labels)"
                              :key="item.id"
                            >
                              {{ item.name }}
                            </v-chip>
                          </template>
                        </user-email-component></v-list
                      >
                    </v-card-subtitle>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-card elevation="0">
                    <v-card-title class="subtitle-1">{{
                      $t("users.dealersDetails.address")
                    }}</v-card-title>
                    <v-card-subtitle>
                      {{ editedItem.address }}
                    </v-card-subtitle>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-card elevation="0">
                    <v-card-title class="subtitle-1">{{
                      $t("users.dealersDetails.city")
                    }}</v-card-title>
                    <v-card-subtitle>
                      {{ editedItem.city }}
                    </v-card-subtitle>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-card elevation="0">
                    <v-card-title class="subtitle-1">{{
                      $t("users.dealersDetails.country")
                    }}</v-card-title>
                    <v-card-subtitle>
                      {{ getCountry(editedItem.country) }}
                    </v-card-subtitle>
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                  v-if="
                    !(
                      editedItem.is_partner_supergroup &&
                      editedItem.is_internal_partner
                    )
                  "
                >
                  <v-card elevation="0">
                    <v-card-title class="subtitle-1"
                      >{{
                        $t(
                          "users.dealersDetails.contactEmailVisibleToCustomers"
                        )
                      }}
                    </v-card-title>
                    <v-card-subtitle>
                      {{ editedItem.email }}
                    </v-card-subtitle>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-card elevation="0">
                    <v-card-title class="subtitle-1">{{
                      $t("users.dealersDetails.website")
                    }}</v-card-title>
                    <v-card-subtitle>
                      {{ editedItem.website }}
                    </v-card-subtitle>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-card elevation="0">
                    <v-card-title class="subtitle-1">{{
                      $t("users.dealersDetails.phone")
                    }}</v-card-title>
                    <v-card-subtitle>
                      {{ editedItem.phone }}
                    </v-card-subtitle>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="close" text
              >{{ $t("users.dealersDetails.cancel") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-layout>
    </v-container>
    <delete-dialog
      :dialog="deleteDialog"
      :item="itemName"
      @agree="remove"
      v-show="false"
    />
    <help-dialog
      :dialog="helpDialog"
      @close="closeHelpDialog"
      v-if="helpDialog.active"
    ></help-dialog>
  </v-content>
</template>

<script>
import api from "@/utils/api.js";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import { mapGetters, mapState } from "vuex";
import HelpDialog from "@/components/dialogs/HelpDialog";
import constraints from "@/utils/constraints";
import PartnerBanner from "@/components/banners/PartnerBanner.vue";
import constants from "@/utils/constants";
import UserEmailComponent from "@/components/miscellaneous/UserEmailComponent";

export default {
  components: { DeleteDialog, HelpDialog, PartnerBanner, UserEmailComponent },
  data: () => ({
    helpDialog: { location: null, active: false },
    accountView: false,
    loading: true,
    canUserDelete: true,
    deleteDialog: false,
    itemName: null,
    partnerBanner: { active: false },
    editedItem: {
      name: "",
      brand_uuids: [],
      crm_group_uuid: "",
      brands: [],
      dealer: [],
      vendor: null,
      domains: [],
      address: "",
      city: "",
      country: "",
      email: "",
      website: "",
      phone: "",
    },
  }),

  computed: {
    ...mapGetters(["getMe"]),
    isInternalPartner() {
      if (
        typeof this.$route.query.my_account !== "undefined" &&
        this.$route.query.my_account &&
        !this.isEditView
      ) {
        return true;
      }

      if (typeof this.editedItem.is_internal_partner === "undefined") {
        return false;
      }

      if (this.editedItem.is_internal_partner) {
        return true;
      }

      return false;
    },
  },

  created() {
    this.canUseKnowledgeBaseBtn = constraints.canUseKnowledgeBaseBtn("account");
    let dealership = this.getMe.dealerships.find(
      (dealership) => dealership.uuid === this.$route.params.id
    );

    if (typeof dealership !== "undefined" && !dealership.is_profile_complete) {
      this.partnerBanner.active = true;
    }

    if (
      typeof this.getMe.dealerships !== "undefined" &&
      this.getMe.dealerships.length !== 0
    ) {
      this.accountView = true;
    }
    let promises = [api.getDealer(this.$route.params.id), api.getDealerList()];

    Promise.all(promises).then((values) => {
      this.editedItem = values[0].data;
      // this.canUserDelete = values[1].data.results.length > 1;
      this.loading = false;
    });
  },

  mounted() {
    //get correct state in vuex
    this.$store.subscribe((mutation, state) => {
      if (
        mutation.type === "USER_ME" &&
        typeof mutation.payload.dealerships !== "undefined" &&
        mutation.payload.dealerships.length !== 0
      ) {
        this.accountView = true;
        this.loading = false;
      }
    });
  },
  methods: {
    getCountry(country) {
      let foundCountry = constants.countries().find((element) => {
        return element.value === country;
      });

      if (typeof foundCountry === "undefined") return country;

      return foundCountry.text;
    },
    closeHelpDialog(event) {
      if (event === "close") {
        this.helpDialog.active = false;
      }
    },
    getRolePrettified(roles) {
      return constants.partnerRoles.filter((item) => {
        return roles.includes(item.server);
      });
    },
    deleteUserDialog(index) {
      this.indexToDelete = index;
      this.cancelDialog.active = true;
    },
    handleHelp(event) {
      this.helpDialog.active = true;
      this.helpDialog.location = "account";
    },
    close() {
      if (
        typeof this.$route.query.my_account !== "undefined" &&
        this.$route.query.my_account === "true"
      ) {
        this.$router.push({
          name: "partners",
          query: this.$route.query,
        });
      } else {
        this.$router.push({
          name: "dealers",
          query: this.$route.query,
        });
      }
    },
    edit() {
      if (
        typeof this.$route.query.my_account !== "undefined" &&
        this.$route.query.my_account === "true"
      ) {
        this.$router.push({
          name: "partnerEdit",
          params: {
            id: this.$route.params.id,
          },
          query: { ...this.$route.query, tab: "info" },
        });
      } else {
        this.$router.push({
          name: "dealerEdit",
          params: {
            id: this.$route.params.id,
          },
          query: { ...this.$route.query, tab: "info" },
        });
      }
    },
    deleteFn() {
      this.deleteDialog = true;
      this.itemName = this.editedItem.name;
    },

    remove(agreed) {
      if (agreed) {
        api.deleteDealer(this.editedItem.uuid).then((resp) => {
          this.$router.push({
            name: "dealers",
            query: this.$route.query,
          });
        });
      }
      this.deleteDialog = false;
    },
  },
};
</script>
<style lang="scss" scoped></style>
